import { combineReducers, configureStore, createAction } from '@reduxjs/toolkit';
import { account, accounts } from './accounts';
import { adjustment, adjustmentLog, adjustments } from './adjustments';
import { admin } from './admin';
import { billing, directDebitMandate, invoice } from './billing';
import { brand } from './brands/brand';
import { brands } from './brands/brands';
import { brandsCategories, brandsCategory } from './brands/brandsCategories';
import { brandsIngredient, brandsIngredients } from './brands/brandsIngredients';
import { brandsMenuItem, brandsMenuItems } from './brands/brandsMenuItems';
import { brandsMenus, brandsMenusList } from './brands/brandsMenus';
import { brandsModifier, brandsModifiers } from './brands/brandsModifiers';
import { brandsOption, brandsOptions } from './brands/brandsOptions';
import { brandsVenueAssociations } from './brands/brandsVenueAssociations';
import { builderMenuItems } from './brands/builderMenu/builderMenuItems';
import { builderMenu, builderMenus } from './brands/builderMenu/builderMenus';
import { venueBrands } from './brands/venueBrands';
import { campaign } from './campaign';
import { campaigns } from './campaigns';
import { cashup, cashupHistory } from './cashups';
import { categories, category } from './categories';
import { customer } from './customer';
import { debits } from './debits';
import { deliveryStatements } from './deliveryStatements';
import { availableDeviceCapabilities, availableDevices, device, devices } from './devices';
import { dietaryRequirements } from './dietaryRequirements';
import { floats } from './floats';
import { imageGallery } from './imageGallery';
import { imagesReview } from './imagesReview';
import { ingredient, ingredients } from './ingredients';
import { intercom } from './intercom';
import { introTask, introTasks } from './introTasks';
import { discount, discounts } from './itemDiscounts';
import { kioskOnboardingKey, kiosks } from './kiosks';
import { manager, managers } from './managers';
import { menuItem, menuItems } from './menuItems';
import { mobileDevice, mobileDevices, onboardingDeviceKey } from './mobiles';
import { modifier, modifiers } from './modifiers';
import { option, options } from './options';
import { order, orders, ordersLive, ordersTakeaway, polarisOrders } from './orders';
import { payments } from './payments';
import { cardPayouts } from './payouts-card';
import { externalPayout, externalPayouts } from './payouts-external';
import { bannerGallery, personalisation } from './personalisation';
import { platformInvoices } from './platformInvoices';
import { availablePrinters, printer, printers } from './printers';
import { promoCode, promoCodes } from './promoCodes';
import { promotion, promotions } from './promotions';
import { availableQrcodes, qrcode, qrcodes } from './qrcodes';
import {
  deliveryMetrics,
  reportCustomersOverview,
  reportOverview,
  reportRepeatCustomers,
  reportSalesByArea,
  reportSalesByCategory,
  reportSalesByItem,
  reportSalesByStaff,
  reportSalesByTable,
  reportSalesOverview,
  reportTipsByStaff,
  reportTopCustomers,
} from './reports';
import { reviews } from './reviews';
import { salesArea, salesAreas } from './salesAreas';
import { search } from './search';
import { serviceStatus } from './serviceStatus';
import { authentication, refreshSession, session } from './session';
import { sessionsScore } from './sessionsScore';
import { signup } from './signup';
import { staff, staffAll } from './staff';
import { table, tables } from './tables';
import { tab, tabs } from './tabs';
import { availableTerminalDevices, terminalDevice, terminalDevices } from './terminals';
import { theme } from './theme';
import { till, tills } from './tills';
import {
  smartUpsellGroup,
  smartUpsellGroupInitiatingItems,
  upsellGroup,
  upsellGroupInitiatingItems,
  upsellGroups,
} from './upsellGroups';
import { venueFees } from './venueFees';
import { venueMenuItems } from './venueMenuItems';
import { venueMenu, venueMenuStatus, venueMenus } from './venueMenus';
import {
  venue,
  venueAdditionalCharges,
  venueHideGMVSetting,
  venuePriorities,
  venueSettings,
  venues,
} from './venues';
import { voucher, vouchers } from './vouchers';

import { setRefreshSession, setStore } from '../api/httpRequest';
import { payout } from './payout';

const app = combineReducers({
  authentication,
  session,
});

export const reducer = combineReducers({
  accounts,
  account,
  admin,
  promotions,
  promotion,
  adjustments,
  adjustment,
  adjustmentLog,
  app,
  billing,
  bannerGallery,
  builderMenu,
  builderMenus,
  builderMenuItems,
  brand,
  brands,
  brandsMenus,
  brandsMenusList,
  brandsVenueAssociations,
  brandsMenuItems,
  brandsMenuItem,
  brandsOptions,
  brandsOption,
  brandsIngredients,
  brandsIngredient,
  brandsModifiers,
  brandsModifier,
  brandsCategories,
  brandsCategory,
  campaigns,
  campaign,
  categories,
  category,
  customer,
  debits,
  deliveryMetrics,
  device,
  devices,
  directDebitMandate,
  discounts,
  discount,
  availableTerminalDevices,
  terminalDevice,
  terminalDevices,
  floats,
  mobileDevice,
  mobileDevices,
  kiosks,
  kioskOnboardingKey,
  onboardingDeviceKey,
  dietaryRequirements,
  availableDevices,
  availableDeviceCapabilities,
  qrcodes,
  qrcode,
  promoCodes,
  promoCode,
  availableQrcodes,
  invoice,
  imageGallery,
  imagesReview,
  ingredients,
  ingredient,
  introTasks,
  introTask,
  managers,
  manager,
  menuItems,
  menuItem,
  modifiers,
  modifier,
  options,
  option,
  order,
  orders,
  ordersLive,
  ordersTakeaway,
  personalisation,
  polarisOrders,
  printer,
  printers,
  availablePrinters,
  payments,
  payout,
  salesArea,
  salesAreas,
  reportSalesByStaff,
  reportSalesOverview,
  reportSalesByArea,
  reportSalesByItem,
  reportSalesByTable,
  reportSalesByCategory,
  reportTipsByStaff,
  reportCustomersOverview,
  reportOverview,
  reportRepeatCustomers,
  reportTopCustomers,
  search,
  serviceStatus,
  sessionsScore,
  staff,
  staffAll,
  signup,
  tab,
  tables,
  table,
  tabs,
  till,
  tills,
  theme,
  venues,
  venue,
  venueFees,
  venueMenus,
  venueMenu,
  venueMenuStatus,
  venueSettings,
  venuePriorities,
  venueAdditionalCharges,
  venueHideGMVSetting,
  venueMenuItems,
  venueBrands,
  vouchers,
  voucher,
  cardPayouts,
  externalPayouts,
  externalPayout,
  reviews,
  upsellGroup,
  upsellGroups,
  smartUpsellGroup,
  upsellGroupInitiatingItems,
  smartUpsellGroupInitiatingItems,
  cashup,
  cashupHistory,
  platformInvoices,
  deliveryStatements,
  intercom,
});

// In order to clear most of the state, we need access to it at the store level.
const rootReducer = (state, action) => {
  if (action.type === 'reset-venue') {
    return reducer({ app: state.app, venues: state.venues, search: state.search }, action);
  }

  return reducer(state, action);
};

export const resetVenue = createAction('reset-venue', () => ({
  reset: true,
}));

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
    }),
});

export default store;

setStore(store);
setRefreshSession(refreshSession);
